<template>
  <div
    :class="{ 'd-flex align-center flex-column': label && !withoutLabel }"
    class="icon-label-btn"
    v-bind="attrs"
  >
    <v-btn
      class="my-0"
      icon
      :size="size"
    >
      <icon :fill="color" :height="height" :width="width">
        {{ iconSlotText }}
      </icon>
    </v-btn>

    <div
      v-if="label && !withoutLabel"
      class="icon-label mt-n1 text-center w-100"
      :class="labelClass"
      style="line-height: 1.2"
    >
      {{ label }}
    </div>
  </div>
</template>

<script setup>
import { computed, useAttrs, useSlots } from 'vue'

defineOptions({
  inheritAttrs: false
})

/* ---------------- props ---------------- */

const props = defineProps({
  color: {
    type: String,
    default: 'primary'
  },
  size: {
    type: [Number, String],
    default: 32
  },
  label: {
    type: [Boolean, String]
  },
  labelClass: {
    type: [Boolean, String],
    default: ''
  },
  withoutLabel: Boolean
})

/* ---------------- slots / attrs ---------------- */

const attrs = useAttrs()
const slots = useSlots()

/* ---------------- computed ---------------- */

const iconSlotText = computed(() => {
  const content = slots.default?.()
  if (!content?.length) return ''
  const first = content[0]
  if (typeof first?.children === 'string') return String(first.children).trim()
  if (Array.isArray(first?.children)) {
    const text = first.children.find(c => typeof c === 'string')
    return text ? String(text).trim() : ''
  }
  return ''
})

const height = computed(() =>
  props.label && !props.withoutLabel ? 20 : 24
)

const width = computed(() =>
  props.label && !props.withoutLabel ? 20 : 24
)
</script>

<style scoped>
.icon-label-btn {
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

/* Clicks are bound on the wrapper; the inner v-btn sits on top in the stacking
   order. On iOS Chrome/Safari the first tap often hit the button (ripple/highlight)
   without the wrapper's @click firing. */
.icon-label-btn :deep(.v-btn) {
  pointer-events: none;
}

.share-pass-btn :deep(.v-btn) {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
</style>
